import Error404 from '@src/pages/Error404';
import React from 'react';
import { useLocation } from 'react-router-dom';

interface LocationState {
  session: string;
}

type Props = {
  children: React.ReactNode;
  isTenant: boolean;
};

const TwoFactorGuard: React.FC<Props> = ({ children, isTenant }) => {
  const { state } = useLocation() as { state: LocationState | null };

  // stateがnullまたはsessionが空の場合はError404をレンダリング
  if (!state || !state.session || state.session === '') {
    return <Error404 isTenant={isTenant} />;
  }

  return <>{children}</>;
};

export default TwoFactorGuard;
